
// You can write more code here

/* START OF COMPILED CODE */

import EntityRelic from "../EntityRelic";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class RelicSkull extends EntityRelic {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 74, y ?? 47);

    // boots
    const skull = scene.add.image(0, 0, 'game-all', 'relic-skull.png');
    skull.scaleX = 0.5;
    skull.scaleY = 0.5;
    this.add(skull);

    this.skull = skull;

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  private skull: Phaser.GameObjects.Image;

  /* START-USER-CODE */

  protected injectMatter(target: Phaser.GameObjects.GameObject) {
    this.setSize(this.skull.displayWidth, this.skull.displayHeight);

    super.injectMatter(target);
  }
}

/* END OF COMPILED CODE */

// You can write more code here
